import Yup from '../../i18n/yup'


export const validationSchema = Yup.object().shape({
  terms: Yup.string().max(20000).required(),
  privacy: Yup.string().max(20000).required(),
})

export const formsInputsData = [
  {
    id: 'terms',
    title: 'LEGAL_TEXT.FORMS_INPUTS.TERMS',
    type: 'textarea',
    iconName: 'name',
  },
  {
    id: 'privacy',
    title: 'LEGAL_TEXT.FORMS_INPUTS.PRIVACY',
    type: 'textarea',
    iconName: 'name',
  },
]
